import { buildMetadata, getRouteInfo, site } from '../../config/seo-metadata';

function setMeta(attribute, key, content) {
  const selector = `meta[${attribute}="${key}"]`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

export function updateSeo(path, data, menu) {
  const meta = buildMetadata(path, data, menu);
  document.documentElement.lang = 'zh-CN';
  document.title = meta.title;
  setMeta('name', 'description', meta.description);
  setMeta('name', 'robots', meta.robots);
  // Do not repeat the homepage's keyword list on unrelated detail or private pages.
  const keywords = document.head.querySelector('meta[name="keywords"]');
  if (keywords) keywords.parentNode.removeChild(keywords);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!meta.canonical && canonical) canonical.parentNode.removeChild(canonical);
  if (meta.canonical) {
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = meta.canonical;
  }
  ['title', 'description', 'image', 'type'].forEach(key => setMeta('property', `og:${key}`, meta[key]));
  setMeta('property', 'og:url', meta.canonical);
  setMeta('property', 'og:site_name', site.siteName);
  setMeta('property', 'og:locale', 'zh_CN');
  setMeta('name', 'twitter:card', 'summary');
  ['title', 'description', 'image'].forEach(key => setMeta('name', `twitter:${key}`, meta[key]));
  let structured = document.getElementById('site-seo-jsonld');
  if (!structured) {
    structured = document.createElement('script');
    structured.id = 'site-seo-jsonld';
    structured.type = 'application/ld+json';
    document.head.appendChild(structured);
  }
  structured.textContent = JSON.stringify(meta.structuredData).replace(/</g, '\\u003c');
}

export default {
  install(Vue) {
    Vue.mixin({
      created() {
        if (!this.$route) return;
        const initial = getRouteInfo(this.$route.path);
        const owns = key => Object.prototype.hasOwnProperty.call(this.$data, key);
        if (initial.dataKey && owns(initial.dataKey)) {
          this.$watch(() => this[initial.dataKey], (data) => {
            const active = getRouteInfo(this.$route.path);
            if (active.dataKey !== initial.dataKey || !data || String(data.id) !== active.id) return;
            updateSeo(this.$route.path, data);
          }, { deep: true, immediate: true });
        }
        if (initial.catalog && owns('menuList') && owns('facultyId')) {
          this.$watch(() => [this.$route.path, this.menuList], () => {
            if (getRouteInfo(this.$route.path).catalog) updateSeo(this.$route.path, null, this.menuList);
          }, { deep: true, immediate: true });
        }
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/seo/index.js